import { useAccount } from './UseAccount';

// The provider's currency object ({ code, symbol, decimals }) as returned on
// /providers/me and every provider serialisation. Used for provider-context
// money (payouts, balance, financial overview, pricing inputs). Returns
// undefined when absent, which UseCurrencyDecorator treats as EUR.
export const useProviderCurrency = () => {
	const account = useAccount();
	return account?.currency;
};
